export const user_role_display_name = {
    broker: "Broker",
    dataEntry: "CDT",
    dataAdmin: "Admin",
    portlandBrokerAdmin: "Portland Broker Admin",
    arizonaBrokerAdmin: "Arizona Broker Admin",
    accounting: "Accounting",
    propertyManagement: "Asset Services",
    evp: "RP",
    general: "General User",
    officeManager: "Office Manager",
    researchAdmin: "Research Admin",
    research: "Research",
    transition: "Transition Specialist",
    anonymous: "Anonymous",
    debtEquity: "Debt & Equity",
    appraiser: "Appraiser",
    auditor: "Auditor",
};

export const user_role_type_display_name = {
    ROLE_ACCOUNTING: "Accounting",
    ROLE_ADMIN: "Admin",
    ROLE_ARIZONA_BROKER_ADMIN: "Arizona Broker Admin",
    ROLE_APPRAISER: "Appraiser",
    ROLE_BROKER: "Broker",
    ROLE_PROPERTY_DATA_ENTRY: "CDT",
    ROLE_DEBT_EQUITY: "Debt & Equity",
    ROLE_GENERAL_USER: "General User",
    ROLE_OFFICE_MANAGER: "Office Manager",
    ROLE_PORTLAND_ADMIN: "Portland Broker Admin",
    ROLE_PROPERTY_MANAGEMENT: "Asset Services",
    ROLE_RESEARCH_ADMIN: "Research Admin",
    ROLE_RESEARCH: "Research",
    ROLE_EVP: "RP",
    ROLE_TRANSITION_SPECIALIST: "Transition Specialist",
};

export const all_user_types = [
    "Broker",
    "CDT",
    "Admin",
    "Portland Broker Admin",
    "Accounting",
    "Asset Services",
    "RP",
    "General User",
    "Officer Manager",
    "Research Admin",
    "Research",
    "Transition Specialist",
    "Debt & Equity",
    "Arizona Broker Admin",
    "Office Manager",
    "Appraiser",
    "Auditor",
];

export const notificationModalInfo = [
    {
        title: "Update: Status Tracker",
        description:
            "It can be hard to know where your listing or deal stands on the path to completion. Our new status tracker shows you the progress so far and what's left before it's done.",
        src: "https://s3.us-east-2.amazonaws.com/connect.kidder.com/content/feature-notifications/WD-1981-Status_Tracker/WD-1981_Overview.mp4",
        interval: 10000,
    },
    {
        title: "Update: Status Tracker",
        description:
            "Each step includes informational text showing the current status and who to contact if you need additional support.",
        src: "https://s3.us-east-2.amazonaws.com/connect.kidder.com/content/feature-notifications/WD-1981-Status_Tracker/WD-1981_Content.mp4",
        interval: 8000,
    },
    {
        title: "Update: Status Tracker",
        description: "Hover over each step to reveal tooltips with more detail about that stage of the process.",
        src: "https://s3.us-east-2.amazonaws.com/connect.kidder.com/content/feature-notifications/WD-1981-Status_Tracker/WD-1981_Tooltip.mp4",
        interval: 10000,
    },
];
